export default {
  setLoading(st, { loading }) {
    st.cashback.loading = loading;
  },

  setBalance(st, balance) {
    st.cashback.balance = balance;
  },

  setTransactions(st, transactions) {
    st.cashback.transactions = transactions;
  },

  appendTransactions(st, transactions) {
    st.cashback.transactions = [...st.cashback.transactions, ...transactions];
  },

  setNextCursor(st, cursor) {
    st.cashback.nextCursor = cursor;
  },

  setHasMore(st, hasMore) {
    st.cashback.hasMore = hasMore;
  },

  setLoadingMore(st, { loadingMore }) {
    st.cashback.loadingMore = loadingMore;
  },

  setTotalCount(st, { totalCount }) {
    st.cashback.totalCount = totalCount;
  },

  setMessages(st, message) {
    st.cashback.messages.push(message);
  },

  clearMessages(st) {
    st.cashback.messages.length = 0;
  },
};
